/*
 * TimeListened component: takes a time in seconds and renders a formattedMessage
 * of the type '2 hours listened' or '26 seconds listened'
 */
import has from 'lodash/has';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { timeListenedStrings } from '../../../constants/StationConstants';

const timeTypes = ['seconds', 'minutes', 'hours', 'days'];

class TimeListened extends React.Component {
  static propTypes = {
    secondsListened: PropTypes.number.isRequired,
    maxTimeUnit: PropTypes.oneOf(timeTypes),
  };

  static defaultProps = {
    maxTimeUnit: 'hours',
  };

  render() {
    if (!has(this.props, 'secondsListened')) {
      return null;
    }

    const seconds = this.props.secondsListened;

    switch (this.props.maxTimeUnit) {
      case 'days': {
        const days = Math.round((seconds / 60 / 60 / 24) * 10) / 10;
        if (days && days > 1) {
          return <FormattedMessage {...timeListenedStrings.daysListened} values={{ days }} />;
        } // if < 1 day, fall through to hours
      }
      case 'hours': {
        const hours = Math.round(seconds / 60 / 60);
        if (hours) {
          return <FormattedMessage {...timeListenedStrings.hoursListened} values={{ hours }} />;
        } // if < 1 hour, fall through to minutes
      }
      case 'minutes': {
        const minutes = Math.round(seconds / 60);
        if (minutes) {
          return <FormattedMessage {...timeListenedStrings.minutesListened} values={{ minutes }} />;
        } // if < 1 minute, fall through to seconds
      }
      default:
        return <FormattedMessage {...timeListenedStrings.secondsListened} values={{ seconds }} />;
    }
  }
}

export default TimeListened;
